var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLocationMarker(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 13,
    viewBox: "0 0 10 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.53496 1.835C2.45394 0.916025 3.70034 0.39975 4.99996 0.39975C6.29959 0.39975 7.54599 0.916025 8.46496 1.835C9.38394 2.75397 9.90021 4.00037 9.90021 5.3C9.90021 6.59963 9.38394 7.84602 8.46496 8.765L4.99996 12.23L1.53496 8.765C1.0799 8.30999 0.718927 7.76979 0.472648 7.17526C0.226368 6.58074 0.0996094 5.94352 0.0996094 5.3C0.0996094 4.65648 0.226368 4.01926 0.472648 3.42474C0.718927 2.83021 1.0799 2.29001 1.53496 1.835ZM4.99996 6.7C5.37127 6.7 5.72736 6.5525 5.98991 6.28995C6.25246 6.0274 6.39996 5.6713 6.39996 5.3C6.39996 4.9287 6.25246 4.5726 5.98991 4.31005C5.72736 4.0475 5.37127 3.9 4.99996 3.9C4.62866 3.9 4.27257 4.0475 4.01001 4.31005C3.74746 4.5726 3.59996 4.9287 3.59996 5.3C3.59996 5.6713 3.74746 6.0274 4.01001 6.28995C4.27257 6.5525 4.62866 6.7 4.99996 6.7Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationMarker);
export default __webpack_public_path__ + "static/media/location_marker.f3a287c36713ca5a1f7e5a0abf525e38.svg";
export { ForwardRef as ReactComponent };